import VisualSearchButton from 'components/VisualSearch'
import React, { FC } from 'react'
import styles from './HeaderSearch.module.scss'
import useSearchProvider from 'components/SA/SearchProvider/hooks/useSearchProvider'
import { SearchOptionLinksObject } from 'components/SA/SearchProvider/types'
import SearchOptionLinks from './components/SearchOptionLinks'
import PopularSearches from './components/PopularSearches'

type SearchMenuContentProps = {
  suggestions: ReadonlyArray<SearchOptionLinksObject>
  recentSearches: ReadonlyArray<SearchOptionLinksObject>
  popularSearches: ReadonlyArray<SearchOptionLinksObject>
  setIsFocused: (isFocused: boolean) => void
  onRecentSearchRemove: (label: string) => void
  onSearch: (query: string) => void
  matchedTerm?: string
}

const SearchMenuContent: FC<SearchMenuContentProps> = ({
  suggestions,
  recentSearches,
  popularSearches,
  setIsFocused,
  onRecentSearchRemove,
  onSearch,
  matchedTerm,
}) => {
  const { getSearchProviderAttributes } = useSearchProvider()

  return (
    <div
      className={styles.searchDropdownBox}
      {...getSearchProviderAttributes([{ 'autocomplete-container': true }])}
    >
      <SearchOptionLinks
        title='Suggestions'
        options={suggestions}
        setIsFocused={setIsFocused}
        onSearch={onSearch}
        matchedTerm={matchedTerm}
        highlightMatchedTerms={true}
        sectionName='Search Suggestions'
      />
      <SearchOptionLinks
        title='Recent Searches'
        options={recentSearches}
        setIsFocused={setIsFocused}
        onRemove={onRecentSearchRemove}
        onSearch={onSearch}
        icon='recent-search'
      />
      <PopularSearches
        popularSearches={popularSearches}
        setIsFocused={setIsFocused}
        onSearch={onSearch}
      />
      <div className={styles.visualSearchContainer}>
        <VisualSearchButton />
      </div>
    </div>
  )
}

export default SearchMenuContent
